import * as d3 from 'd3';
import { scaleOrdinal, scaleThreshold, scaleQuantize } from 'd3-scale';
import { saveScales, saveData } from '../../actions/index';
import store from '../../store';
import cores from '../../helpers/partidos';
// import { hotFixAppend } from '../../helpers/append';

const { dispatch, getState } = store;


export default async ({ NEWDATA }) => {
  console.log('@@@ in SCALE NEWDATA', NEWDATA);

  const municipios = Object.keys(NEWDATA.municipios)
    .map(item => NEWDATA.municipios[item]);

  const candidatosVencedores = municipios.filter(({ candidatos }) => candidatos)
    .map(({ candidatos }) => (candidatos ? candidatos[0] : null))
    .sort((a, b) => (
      parseInt(b.total_votos_validos.replace(/\D/g, ''), 10) -
      parseInt(a.total_votos_validos.replace(/\D/g, ''), 10)
    ));

  const quantidade = candidatosVencedores.reduce((prev, curr) => {
    prev[curr.id_candidato] = prev[curr.id_candidato] || [];
    prev[curr.id_candidato].push(parseInt(curr.total_votos_validos.replace(/\D/g, ''), 10));
    return prev;
  }, {});

  const posicao = Object.keys(quantidade).map((id) => {
    const total = quantidade[id].reduce((prev, curr) => {
      return prev + curr;
    }, 0);
    return {
      id,
      total,
    };
  }).sort((a, b) => b.total - a.total);

  // const idVencedores = candidatosVencedores
  //   .map(item => item.id_candidato)
  //   .filter((el, index, arr) => arr.indexOf(el) === index);

  // const vencedores = idVencedores.map(item => NEWDATA.candidatos[item]);
  const vencedores = posicao.map(item => NEWDATA.candidatos[item.id]);

  // APPEND NULOS E BRANCOS
  // const newMunicipios = hotFixAppend(municipios);

  // PARA PEGAR O MENOR E MAIOR VOTACAO
  const desempenho = municipios.filter(({ candidatos }) => candidatos)
    .map(({ candidatos }) => candidatos)
    .reduce((prev, curr) => [...prev, ...curr], [])
    .reduce((prev, curr) => {
      prev[curr.id_candidato] = prev[curr.id_candidato] || [];
      prev[curr.id_candidato].push(curr);
      return prev;
    }, {});

  const scales = {
    scaleCandidatos() {
      const range = vencedores.map(({ sigla_partido }) => cores[sigla_partido]); // eslint-disable-line
      const domain = vencedores.map(({ numero_candidato }) => numero_candidato); // eslint-disable-line
      return scaleOrdinal()
        .domain(domain)
        .range(range);
    },
    percentual() {
      return scaleThreshold()
        .domain([50])
        .range([0.6, 1]);
    },
    scaleIndividual() {
      const { initial } = getState();
      const { param } = initial;
      const { currentKey } = param;
      const { param: id_candidato } = currentKey; // eslint-disable-line
      const { candidatos } = NEWDATA;
      const sigla = candidatos[id_candidato].sigla_partido;
      const color = d3.rgb(cores[sigla]);
      const { r, g, b } = color;
      const start = `rgba(${r}, ${g}, ${b}, 1)`;
      const end = `rgba(${r}, ${g}, ${b}, 0.35)`;
      const colors = d3.quantize(d3.interpolateRgb(start, end), 4);
      const minMax = d3.extent(desempenho[id_candidato], e => parseFloat(e.total_percentual.replace(/%/g, '').replace(/,/, '.')));
      console.log('minMax', minMax);
      return scaleQuantize()
        .domain(minMax)
        .range(colors.reverse());
    },
  };

  dispatch(saveScales(scales));
  dispatch(saveData({ vencedores }));

  console.log('@@@ FIM SCALE');
  console.log('');
};



// WEBPACK FOOTER //
// ./src/components/mapa/scale.js